import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое управление изменениями в компании?',
    a: 'Это управленческая работа по переводу компании от старого способа работы к новому: объяснение причин изменений, обучение сотрудников, работа с сопротивлением, поддержка в переходный период и закрепление нового поведения в процессах, стандартах и контроле. Изменения становятся результатом не тогда, когда о них объявили, а когда новое поведение стало частью ежедневной работы.',
  },
  {
    q: 'Почему сотрудники сопротивляются изменениям?',
    a: 'Причины могут быть разными: сотрудник не понимает, зачем нужны изменения, не видит личной выгоды, боится потерять статус, не уверен, что справится, привык к старой системе или не доверяет руководству. Сопротивление не всегда означает саботаж — его нужно понимать и правильно с ним работать, а не просто преодолевать.',
  },
  {
    q: 'Как руководителю работать с сопротивлением сотрудников?',
    a: 'Сначала выявить причину сопротивления и отделить факты от эмоций. Затем объяснить необходимость изменений, дать возможность задать вопросы, обучить, дать безопасную практику, получить обратную связь и закрепить новое поведение в процессах и стандартах. Сопротивление — это сигнал, а не повод для давления.',
  },
  {
    q: 'Как внедрить новые процессы в компании?',
    a: 'Недостаточно объявить о новом процессе — нужно пройти путь от решения к новому стандарту: объяснить причины, убедиться, что сотрудники поняли и приняли изменения, обучить необходимым навыкам, дать практику, поддерживать в переходный период, контролировать качество внедрения и закрепить новое поведение в стандартах.',
  },
  {
    q: 'Как подготовить сотрудников к изменениям?',
    a: 'Объяснить, что меняется и почему, сформировать понятные ожидания, выслушать опасения, дать необходимые знания и навыки и позволить безопасно попробовать новый способ работы. Чем лучше сотрудники понимают изменения и чувствуют поддержку, тем меньше сопротивление и быстрее адаптация.',
  },
  {
    q: 'Как руководителю правильно сообщить команде об изменениях?',
    a: 'Честно и своевременно: объяснить причины и последствия, не создавать ложных ожиданий, отвечать на неудобные вопросы, говорить о неприятных последствиях прямо и вовлекать руководителей среднего звена в донесение информации. Чем меньше информации сотрудники получают от руководства, тем больше домыслов они создают сами.',
  },
  {
    q: 'Как снизить сопротивление изменениям?',
    a: 'Через понимание, вовлечение и поддержку: объяснить необходимость, дать сотрудникам возможность высказать опасения и задать вопросы, обучить новым навыкам, дать практику и закрепить новое поведение. Сопротивление снижается, когда люди понимают изменения и чувствуют, что их не оставили один на один с неопределённостью.',
  },
  {
    q: 'Какие навыки нужны руководителю для управления изменениями?',
    a: 'Коммуникация, лидерство, эмоциональный интеллект, переговоры, работа с конфликтами, постановка задач, контроль и обратная связь, а также мотивация. Руководитель должен уметь объяснять изменения, вести команду через неопределённость и переводить изменения в конкретные действия и закреплённые стандарты.',
  },
  {
    q: 'Подходит ли обучение для новых руководителей?',
    a: 'Да. Новым руководителям важно освоить инструменты управления изменениями вместе с новой управленческой ролью: как объяснять решения, работать с сопротивлением команды и закреплять новые правила работы. Программа адаптируется под уровень участников.',
  },
  {
    q: 'Можно ли адаптировать программу под конкретную компанию?',
    a: 'Да, адаптация — обязательный этап. Сначала мы разбираемся, какие изменения происходят в компании и где возникают основные сложности, затем настраиваем программу под специфику бизнеса, уровень руководителей и характер изменений.',
  },
  {
    q: 'Можно ли проводить обучение онлайн?',
    a: 'Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу компании: корпоративный тренинг, модульная программа, бизнес-игры, коучинг руководителей или сопровождение во время внедрения изменений.',
  },
  {
    q: 'Что происходит после тренинга?',
    a: 'Обучение не заканчивается тренингом. Руководители переносят инструменты в реальную работу, а при необходимости проводится сопровождение: разбираются возникающие сложности, корректируются действия и оцениваются изменения в управленческом поведении и процессах.',
  },
  {
    q: 'Можно ли добавить сопровождение после обучения?',
    a: 'Да. Сопровождение помогает закрепить результаты: разбираем реальные ситуации внедрения изменений, поддерживаем руководителей в сложных разговорах и определяем, какие изменения произошли в управленческом поведении и процессах.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об управлении изменениями в компании
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}